/**
 * Narrows the Training Topics list by whether a topic has any associated courses.
 *
 * `ShowAll` is a real, labeled option rather than a cleared filter: the dropdown is rendered
 * with `clearable={false}`, so users never have to infer that an empty filter means everything.
 */
export enum CourseAvailability {
    ShowAll,
    HasCourses,
    NoCourses,
}
